import axios from 'axios'
import constants from '../lib/constants'

export const GET_PATIENTS = 'GET_PATIENTS'
export const GET_PATIENTS_COMPLETE = 'GET_PATIENTS_COMPLETE'
export const UPDATE_PATIENT = 'UPDATE_PATIENT'
export const UPDATE_PATIENT_COMPLETE = 'UPDATE_PATIENT_COMPLETE'
export const CREATE_PATIENT_COMPLETE = 'CREATE_PATIENT_COMPLETE'

export const getPatients = (siteId) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_PATIENTS })
    return axios.get(`${constants.API_URL}/sites/${siteId}/patients`)
    .then((response) => {
      dispatch({
        type    : GET_PATIENTS_COMPLETE,
        payload : {
          patients: response.data.patients,
        }
      })
      return response
    })
  }
}

export const updatePatientBrand = (patientId, { brand }) => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_PATIENT })
    return axios.post(`${constants.API_URL}/patients/${patientId}/update`, {
      brand
    })
    .then((response) => {
      dispatch({
        type: UPDATE_PATIENT_COMPLETE,
        payload: response.data
      })
    })
  }
}

export const updatePatient = (patientId, values) => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_PATIENT })
    return axios.post(`${constants.API_URL}/patients/${patientId}/update`, values)
    .then((response) => {
      dispatch({
        type: UPDATE_PATIENT_COMPLETE,
        payload: response.data
      })
    })
  }
}

export const createPatient = (
  firstName,
  lastName,
  dateOfBirth,
  phoneNumber,
  phoneNumberType,
  email,
  residenceAddress,
  residenceAddressLat,
  residenceAddressLon,
  race,
  gender,
  prescriberId,
  siteId,
  condition1,
  condition2,
  bloodPressureTestEnabled,
  cardiacCareTestEnabled,
  EKGTestEnabled,
  glucoseTestEnabled,
  heartRateTestEnabled,
  plateletTestEnabled,
  pulseOximetryTestEnabled,
  temperatureTestEnabled,
  WBCTestEnabled,
  weightTestEnabled,
  urineToxicologyTestEnabled,
  patientType,
  insuranceKinds,
  insuranceCompany,
  policyNumber,
  medicareId,
  medicaidId,
  insuranceOtherDetails,
  groupId,
  monitoringFrequency,
  rxBin,
  socialSecurity,
  caretakerName,
  isConcierge,
  isRPM,
  isCardiacCareEnabled,
  ) => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_PATIENT })
    return axios.post(`${constants.API_URL}/patients/create`, {
      first_name: firstName,
      last_name: lastName,
      date_of_birth: dateOfBirth,
      phone_number: phoneNumber,
      phone_number_type: phoneNumberType,
      email: email,
      residence_address: residenceAddress,
      residence_address_lat: residenceAddressLat,
      residence_address_lon: residenceAddressLon,
      race: race,
      gender: gender,
      prescriber_id: prescriberId,
      site_id: siteId,
      condition1: condition1,
      condition2: condition2,
      blood_pressure_test_enabled: bloodPressureTestEnabled,
      cardiac_care_test_enabled: cardiacCareTestEnabled,
      ekg_test_enabled: EKGTestEnabled,
      glucose_test_enabled: glucoseTestEnabled,
      heart_rate_test_enabled: heartRateTestEnabled,
      platelet_test_enabled: plateletTestEnabled,
      pulse_oximetry_test_enabled: pulseOximetryTestEnabled,
      temperature_test_enabled: temperatureTestEnabled,
      wbc_test_enabled: WBCTestEnabled,
      weight_test_enabled: weightTestEnabled,
      urine_toxicology_test_enabled: urineToxicologyTestEnabled,
      patient_type: patientType,
      insurance_kinds: insuranceKinds,
      insurance_company: insuranceCompany,
      policy_number: policyNumber,
      medicare_id: medicareId,
      medicaid_id: medicaidId,
      insurance_other_details: insuranceOtherDetails,
      group_id: groupId,
      monitoring_frequency: monitoringFrequency,
      rx_bin: rxBin,
      social_security: socialSecurity,
      caretaker_name: caretakerName,
      is_concierge: isConcierge,
      is_rpm: isRPM,
      is_cardiac_care_enabled: isCardiacCareEnabled,
    })
    .then((response) => {
      dispatch({
        type: CREATE_PATIENT_COMPLETE,
        payload: response.data
      })
      return response.data
    })
  }
}

const ACTION_HANDLERS = {
  [GET_PATIENTS_COMPLETE] : (state, action) => {
    const { patients } = action.payload
    const patientsObject = _.keyBy(patients, 'id')
    const newState = {
      ...state,
      ...patientsObject
    }
    return newState
  },

  [UPDATE_PATIENT_COMPLETE] : (state, action) => {
    const patient = action.payload
    return {
      ...state,
      [patient.id]: patient
    }
  },

  [CREATE_PATIENT_COMPLETE]: (state, action) => {
    const patient = action.payload
    return {
      ...state,
      [patient.id]: patient
    }
  }
}

// REDUCER

const initialState = {
}

export default function patientsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/patients.js